/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Text_Outline_OptionInputs */



/**
* | output |
* | --- |
* | "Text Outline" |
*
* @param {Styles_Text_Outline_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_text_outline_option = /** @type {((inputs?: Styles_Text_Outline_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Text_Outline_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contour de texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Textgliederung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Struttura del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Структура текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esquema de texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本大纲")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストアウトライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पाठ की रूपरेखा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esboço do texto")
	return /** @type {LocalizedString} */ ("Text Outline")
});